export default "__VITE_ASSET__5$hsNRmE__"